import { AddNotePopupComponent } from './add-note-popup.component';
import { MomentModule } from 'angular2-moment';
import { AppConstants } from './../../shared/constants/constants';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ConsultationStep, GroupConsultationStep } from '../../models/consultation/consultation.model';
import { ConsultationProcessBarService } from './consultation-process-bar.service';
import { ConsultationProcessService } from '../../pages/consultation-process/consultation-process.service';
import { ModifyPatientPopupComponent } from '../../pages/centre/manage-patient-user/modify-patient-popup.component';
import { PopupSummaryTripInformationComponent } from '../../pages/consultation-process/pop-up-summary-trip-information/pop-up-summary-trip-information.component';
import { DialogService } from './../../shared/services/dialog.service';
import { RouterModule } from '@angular/router';
import { GroupRecommendedLabTestPopupComponent } from '../../pages/consultation-process/group-recommended-lab-tests/group-recommeded-lab-tests-popup.component';

@Component({
  selector: 'app-consultation-progress-bar',
  templateUrl: 'consultation-progress-bar.component.html',
  providers: [ConsultationProcessBarService]
})

export class ConsultationProGressBarComponent implements OnInit, OnDestroy {
  public klass = 'consultationProGressBar';
  public subscription: Subscription;
  public appConstants = AppConstants;
  public consultationStep: any = ConsultationStep;
  public consultationLastStep: any = ConsultationStep.ConfirmLabTests;
  public groupConsultationStep = GroupConsultationStep;
  public patientDetail; // patient info for individual consultation
  public groupDetail;   // group info for group consultation
  public filterParam = { id: '', patientId: '' };
  public activeStep = ConsultationStep.PatientDetails;
  public lastedStep = ConsultationStep.PatientDetails;
  public stepConfig;
  public isGroupConsultation = false;
  public isAddNote = false;
  public tripModeArr = ['Offline Mode', 'Online Mode'];
  public tripMode = 0;
  constructor(private router: Router,
    private activeRouter: ActivatedRoute,
    private consultationProcessBarService: ConsultationProcessBarService,
    private consultationProcessService: ConsultationProcessService,
    private dialogService: DialogService) {
    // get activeStep from consultation step
    this.subscription = this.consultationProcessService.getStep().subscribe(
      data => {
        this.activeStep = data.step;
        this.lastedStep = data.lastedStep;
        this.checkShowNote(this.activeStep);
        if (data.hasOwnProperty('patientId')) {
          // individual consultation
          if (data.patientId !== this.filterParam.patientId) {
            this.filterParam.patientId = data.patientId;
            this.filterParam.id = data.id || '';
            this.stepConfig = this.consultationProcessBarService.getRouterLinkConfig();
            this.consultationProcessBarService.getPatientInfo(this.filterParam.patientId).subscribe(
              (result) => {
                if (result) {
                  this.patientDetail = result.json();
                  this.patientDetail.timeStamp = new Date(this.patientDetail.timeStamp);
                  // dispatch patient sex for consultation step component
                  this.consultationProcessService.announcePatientInfo({ sexId: this.patientDetail.sexId, sexName: this.patientDetail.sexName });
                }
              }
            );
          }
        } else {
          // group consultation
          this.consultationLastStep = this.groupConsultationStep.RecommendedLabTests;
          this.isGroupConsultation = true;
          // check if this is group or group template to set stepConfig
          if (this.router.url.includes('group-template')) {
            this.stepConfig = this.consultationProcessBarService.getGroupTemplateRouterLinkConfig();
          } else {
            this.stepConfig = this.consultationProcessBarService.getGroupRouterLinkConfig();
          }

          if (data.id !== this.filterParam.id) {
            this.filterParam.id = data.id;
            this.consultationProcessBarService.getGroupInfo(this.filterParam.id).subscribe(
              (result) => {
                if (result) {
                  this.groupDetail = result.json();
                }
              }
            );
          }
        }
      });
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
  }

  navigateStep(routerLink) {
    this.router.navigate(routerLink);
  }

  onEditPatient() {
    this.dialogService.openComponentDialog(ModifyPatientPopupComponent,
      { id: this.filterParam.patientId, edit: true },
      { width: '80%' }).subscribe(result => {
        // if add user success then reload the list
        if (result) {
          this.consultationProcessBarService.getPatientInfo(this.filterParam.patientId).subscribe(
            (result) => {
              if (result) {
                this.patientDetail = result.json();
                this.patientDetail.timeStamp = new Date(this.patientDetail.timeStamp);
                this.consultationProcessService.announcePatientInfo(this.patientDetail);
              }
            });
        }
      });
  }
  onSummaryTripInformation()
  {
    this.dialogService.openComponentDialog(PopupSummaryTripInformationComponent,     
      { consultationId: this.filterParam.id, patientId: this.filterParam.id },
      { width: '90%' }).subscribe(result => {        
        if (result) {
        }
      });
  }
  onMoveNextStep() {
    const index = this.stepConfig.map(function (e) { return e.step; }).indexOf(this.activeStep);
    if (index < this.stepConfig.length - 1) {
      const data = {
        'stepUrl': this.stepConfig[index + 1].routerLink,
        'isNext': true
      };
      this.consultationProcessService.announceAction(data);
    }

  }

  onMovePrevStep() {
    const index = this.stepConfig.map(function (e) { return e.step; }).indexOf(this.activeStep);
    if (index > 0) {
      const data = {
        'stepUrl': this.stepConfig[index - 1].routerLink,
        'isNext': false
      };
      this.consultationProcessService.announceAction(data);
    }

  }


  isActive(step): boolean {
    if (step === this.activeStep) {
      return true;
    }
    return false;
  }

  /**
   * dispatch onChangeStep event when user click on breakcrum
   * @param event event
   * @param item
   */
  onChangeStep(event, item) {
    if (item.step !== this.activeStep) {
      const data = {
        'stepUrl': item.routerLink,
        'isNext': false,
        'fromSelectDisease': (this.activeStep === ConsultationStep.SelectVaccination) && (item.step > this.activeStep)
      };
      this.consultationProcessService.announceAction(data);
    }
  }

  checkShowNote(step) {
    if (step === ConsultationStep.MedicalConditions || step === ConsultationStep.RecordPreviousVaccines
      || step === ConsultationStep.SelectVaccination || step === ConsultationStep.PrescribeVaccination
      || step === ConsultationStep.SelectPrescriptions || step === ConsultationStep.LabTests) {
      this.isAddNote = true;
    } else {
      this.isAddNote = false;
    }
    if (step === this.consultationStep.TripInformation) {
      this.resetTripMode();
    }
  }
  onAddNote() {
    const data = {
      consultationId: this.filterParam.id,
      activeStep: this.activeStep
    };
    this.dialogService.openComponentDialog(AddNotePopupComponent,
      data).subscribe(
        (result) => {
          if (result) {
          }
        });
  }

  /**
   * dispatch event when user click on Trip information button
   */
  onDispatchTripInfo() {
    this.consultationProcessService.announceTripAction({ action: 'tripInfo' });
  }
  /**
   * dispatch event when user click on Switch to Offline Mode button
   */
  onDispatchTripMode() {
    this.tripMode = this.tripMode === 0 ? 1 : 0;
    this.consultationProcessService.announceTripAction({ action: 'tripMode' });
  }

  resetTripMode() {
    this.tripMode = 0;
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/components/consultation-progress-bar/consultation-progress-bar.component.ts